// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zqojv","logo":"Card_logo__7oTcr","logoImg":"Card_logoImg__CQpBU","publisher":"Card_publisher__YEFaY"};